import {Base} from "@/api/Base"

export class SettingsPut extends Base {
    path = "settings/put"
}